export default __webpack_public_path__ + "static/media/1Wagonar.3bc52c08.jpg";